// require('./bootstrap');
// require('./old/app');

import Vue from 'vue'
import router from '~/router'
import store from '~/store'
import "vue-material-design-icons/styles.css"
import '~/plugins'
import '~/components';
import _ from "lodash";
import {library} from '@fortawesome/fontawesome-svg-core'
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueTheMask from 'vue-the-mask'
import {Drag, Drop} from 'vue-drag-drop';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VCalendar from 'v-calendar';
import i18n from "./i18n";
// import PrimeVue from 'primevue/config';
// Vue.use(PrimeVue);
const dev_mode = window.location.host === 'kriton.safecontrol.sofar'
window._log_ = (() => {
    if (dev_mode) {
        return console.log;
    } else return () => {
    };
})();

Vue.use(VCalendar)

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
// import RouterEngine from "~/api/router";

// window.RouterEngine=RouterEngine

Vue.component('drag', Drag);
Vue.component('drop', Drop);


Vue.use(VueTheMask)


import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

Vue.use(VueVirtualScroller)

// import {} from "@fortawesome/free-regular-svg-icons";

import {fas} from "@fortawesome/free-solid-svg-icons";
import {Notification} from "element-ui";
import {getApiAuthToken} from "./api/laravel";

// import { faGithub } from "@fortawesome/free-brands-svg-icons";

library.add(
    fas
);

Vue.component("fa", FontAwesomeIcon);
Number.prototype.formatMoney = function (c, d, t) {
    var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0)
            .toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j)
        .replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i)
        .toFixed(c)
        .slice(2) : "");
};

window.REPO = {bookings: ['hell'], excursion: {}}


const app = new Vue({
    router,
    store,
    i18n,
    el: '#app',
    methods: {
        $makeQueryParam(name) {
            let Q = {}
            Q[v] = {
                get() {
                    return this.$route.query[name]
                },
                set(v) {
                    let setter = {}
                    setter[name] = v
                    this.routeGo({query: setter})
                }
            }
        }
    },
    async mounted() {
        _log_('START-----------------------VUE-----------')
        if (Api.access_token &&!window.localStorage.getItem("access_token")) {
            window.localStorage.setItem("access_token", Api.access_token)
            window.localStorage.setItem("access_token_time_up", (new Date()).getTime())
        }else{
            const xt = window.localStorage.getItem("access_token_time_up") || 0, hH = 1000 * 30 * 60
            // _log_('getApiAuthToken in ', ((new Date()).getTime() - xt) / 60000)
            if (!xt || (((new Date()).getTime() - xt) / 60000 > 30)) {
                window.localStorage.setItem("access_token", Api.access_token)
                window.localStorage.setItem("access_token_time_up", (new Date()).getTime())
            }
        }
    }
});

